var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRfqSendWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Bold/Info Circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Info Circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Info Circle_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_18440_115746",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 1.5C4.86 1.5 1.5 4.86075 1.5 9C1.5 13.1407 4.86 16.5 9 16.5C13.1475 16.5 16.5 13.1407 16.5 9C16.5 4.86075 13.1475 1.5 9 1.5V1.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M9 1.5C4.86 1.5 1.5 4.86075 1.5 9C1.5 13.1407 4.86 16.5 9 16.5C13.1475 16.5 16.5 13.1407 16.5 9C16.5 4.86075 13.1475 1.5 9 1.5V1.5Z",
    fill: "#F38D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 0.5C4.30765 0.5 0.5 4.30853 0.5 9H2.5C2.5 5.41297 5.41235 2.5 9 2.5V0.5ZM0.5 9C0.5 13.6931 4.30778 17.5 9 17.5V15.5C5.41222 15.5 2.5 12.5884 2.5 9H0.5ZM9 17.5C13.7004 17.5 17.5 13.6924 17.5 9H15.5C15.5 12.5891 12.5946 15.5 9 15.5V17.5ZM17.5 9C17.5 4.30918 13.7005 0.5 9 0.5V2.5C12.5945 2.5 15.5 5.41232 15.5 9H17.5Z",
    fill: "white",
    mask: "url(#path-1-inside-1_18440_115746)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M9.00766 12.5117C8.64016 12.5117 8.34766 12.2117 8.34766 11.8517C8.34766 11.4917 8.64016 11.1992 9.00016 11.1992C9.36766 11.1992 9.66016 11.4917 9.66016 11.8517C9.66016 12.2117 9.36766 12.5117 9.00766 12.5117V12.5117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M8.33984 6.15609C8.33984 5.79684 8.63984 5.49609 8.99984 5.49609C9.35984 5.49609 9.65234 5.79684 9.65234 6.15609V9.47109C9.65234 9.83184 9.35984 10.1236 8.99984 10.1236C8.63984 10.1236 8.33984 9.83184 8.33984 9.47109V6.15609Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRfqSendWarning);
export default __webpack_public_path__ + "static/media/rfq-send-warning.3239df373879e7b7718a00afd3a93e19.svg";
export { ForwardRef as ReactComponent };